/* Kashmiri Anchar — Coming Soon theme scripts. No dependencies. */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ------------------------------------------------------------------
     Countdown — every [data-countdown] element ticks toward its ISO date
     ------------------------------------------------------------------ */
  var countdowns = [];
  var timer = null;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function parseLaunch(value) {
    if (!value) return NaN;
    var v = String(value).trim();
    var t = Date.parse(v);
    if (isNaN(t)) {
      // Allow "2026-11-01 00:00 +0530" style values too
      t = Date.parse(v.replace(' ', 'T').replace(/\s?([+-]\d{2}):?(\d{2})$/, '$1:$2'));
    }
    return t;
  }

  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-countdown]').forEach(function (el) {
      if (el.__cd) return;
      var target = parseLaunch(el.getAttribute('data-countdown'));
      if (isNaN(target)) {
        el.classList.add('is-invalid');
        return;
      }
      el.__cd = {
        target: target,
        days: el.querySelector('[data-unit="days"]'),
        hours: el.querySelector('[data-unit="hours"]'),
        minutes: el.querySelector('[data-unit="minutes"]'),
        seconds: el.querySelector('[data-unit="seconds"]'),
        sr: el.querySelector('[data-countdown-sr]'),
        lastMinute: -1
      };
      countdowns.push(el);
    });
    tick();
    if (!timer && countdowns.length) {
      timer = window.setInterval(tick, 1000);
    }
  }

  function tick() {
    var now = Date.now();
    countdowns.forEach(function (el) {
      var cd = el.__cd;
      if (!cd || !el.isConnected) return;
      var diff = Math.max(0, Math.floor((cd.target - now) / 1000));
      if (diff === 0) {
        el.classList.add('is-done');
        return;
      }
      el.classList.remove('is-done');
      var d = Math.floor(diff / 86400);
      var h = Math.floor((diff % 86400) / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      if (cd.days) cd.days.textContent = pad(d);
      if (cd.hours) cd.hours.textContent = pad(h);
      if (cd.minutes) cd.minutes.textContent = pad(m);
      if (cd.seconds) cd.seconds.textContent = pad(s);
      if (cd.sr && m !== cd.lastMinute) {
        cd.lastMinute = m;
        cd.sr.textContent = d + ' days, ' + h + ' hours and ' + m + ' minutes until launch.';
      }
    });
    countdowns = countdowns.filter(function (el) { return el.isConnected; });
  }

  /* ------------------------------------------------------------------
     Header — soften background once the page scrolls
     ------------------------------------------------------------------ */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var ticking = false;
    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();

    var toggle = header.querySelector('[data-menu-toggle]');
    var menu = header.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    function openMenu() {
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      header.classList.add('is-menu-open');
      window.requestAnimationFrame(function () { menu.classList.add('is-open'); });
    }
    function closeMenu(focusToggle) {
      toggle.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
      header.classList.remove('is-menu-open');
      document.documentElement.style.overflow = '';
      window.setTimeout(function () {
        if (toggle.getAttribute('aria-expanded') === 'false') menu.hidden = true;
      }, 450);
      update();
      if (focusToggle) toggle.focus();
    }

    toggle.addEventListener('click', function () {
      toggle.getAttribute('aria-expanded') === 'true' ? closeMenu() : openMenu();
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') closeMenu(true);
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (mq) {
      if (mq.matches && toggle.getAttribute('aria-expanded') === 'true') closeMenu();
    });
  }

  /* ------------------------------------------------------------------
     Reveal on scroll
     ------------------------------------------------------------------ */
  var revealObserver = null;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.reveal, .reveal-image, .reveal-rise');
    if (!els.length) return;

    var skip = prefersReducedMotion || designMode ||
      !document.documentElement.classList.contains('has-motion') ||
      !('IntersectionObserver' in window);

    if (skip) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) {
      if (!el.classList.contains('is-visible')) revealObserver.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     Pickle carousel progress (mobile)
     ------------------------------------------------------------------ */
  function initPickleTracks(root) {
    (root || document).querySelectorAll('[data-pickle-track]').forEach(function (track) {
      var section = track.closest('section');
      var bar = section && section.querySelector('[data-pickle-progress]');
      if (!bar || track.__progress) return;
      track.__progress = true;

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var railWidth = bar.parentElement.clientWidth - parseFloat(getComputedStyle(bar).left || 0) * 2;
        var ratio = max > 0 ? track.clientWidth / track.scrollWidth : 1;
        var width = Math.max(railWidth * ratio, 40);
        var progress = max > 0 ? track.scrollLeft / max : 0;
        bar.style.width = width + 'px';
        bar.style.transform = 'translateX(' + (railWidth - width) * progress + 'px)';
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ------------------------------------------------------------------
     Store password dialog (password page only)
     ------------------------------------------------------------------ */
  function initPasswordDialog() {
    var dialog = document.querySelector('[data-password-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-password-open]')) {
        dialog.showModal();
        var input = dialog.querySelector('input[type="password"]');
        if (input) input.focus();
      }
      if (e.target.closest('[data-password-close]')) dialog.close();
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    if (dialog.querySelector('[data-password-has-errors]')) dialog.showModal();
  }

  /* ------------------------------------------------------------------
     After a waitlist submission, bring the message into view
     ------------------------------------------------------------------ */
  function focusFormStatus() {
    var status = document.querySelector('[data-form-status]');
    if (!status) return;
    var section = status.closest('section');
    if (section) section.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
    window.setTimeout(function () {
      status.scrollIntoView({ block: 'center', behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      if (status.hasAttribute('tabindex')) status.focus({ preventScroll: true });
    }, 60);
  }

  /* ------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------ */
  function init() {
    initCountdowns();
    initHeader();
    initReveals();
    initPickleTracks();
    initPasswordDialog();
    focusFormStatus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-initialise sections as they are added or changed
  document.addEventListener('shopify:section:load', function (e) {
    initCountdowns(e.target);
    initReveals(e.target);
    initPickleTracks(e.target);
    if (e.target.querySelector('[data-header]')) initHeader();
  });
})();
